import axios from 'axios';

export const getCustomerReport = async (users) => axios.get(`/api/reports/customer/?users=${users.join(",")}`);
export const getBlockReport = async (blockIds) => axios.get(`/api/reports/block/?blockIds=${blockIds.join(",")}`);

export const getAnomalySummaryReport = async ({ ranch, dateStart, dateEnd }) => {
  return axios.get(`/api/reports/anomaly/${ranch}/?dateStart=${dateStart}&dateEnd=${dateEnd}`);
}
